import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/Header/Header";
import s from "./Users.module.scss";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getAdminUsersList,
  getUserDetails,
  setUsersCurrentPage,
} from "../../redux/UserSlice";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import Footer from "../../components/Footer/Footer";
import { Link } from "react-router-dom";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import MobileUsersListTable from "../MobileUsersListTable/MobileUsersListTable";
import { useTranslation } from "react-i18next";

interface TableType {
  number: number;
  name: string;
  email: string;
  phone: string;
  role: string;
  is_active: string;
  email_verified: string;
}

const Users = () => {
  const usersList = useSelector(
    (state: RootState) => state.user.adminUsersList
  );
  const [users, setUsers] = useState(usersList);
  const { t } = useTranslation();
  const dispatch: AppDispatch = useDispatch();
  const { width } = useWindowDimensions();
  const [pagination, setPagination] = useState({
    current: users?.pagination?.current_page || 1,
    pageSize: users?.pagination?.page_size || 30,
    total: users?.pagination?.total_items || 100,
  });
  const [currentPage, setCurrentPage] = useState<number>(
    users?.pagination?.current_page || 1
  );

  const columns: ColumnsType<TableType> = [
    {
      title: "№",
      dataIndex: "number",
      width: 20,
      align: "center",
    },
    {
      title: t("ФИО пользователя"),
      dataIndex: `name`,
      width: 150,
    },
    {
      title: t("Email"),
      dataIndex: `email`,
      width: 100,
    },
    {
      title: t("Телефон"),
      dataIndex: `phone`,
      width: 100,
    },
    {
      title: t("Роль"),
      dataIndex: `role`,
      width: 50,
      align: "center",
    },
    {
      title: t("Активный"),
      dataIndex: `is_active`,
      width: 50,
      align: "center",
      render: (text) => (
        <div className={s.font}>
          {text === t("Да") ? (
            <CheckCircleOutlined className={s.green} />
          ) : (
            <CloseCircleOutlined className={s.red} />
          )}
        </div>
      ),
    },
    {
      title: t("Верифицирован"),
      dataIndex: `email_verified`,
      width: 50,
      align: "center",
      render: (text) => (
        <div className={s.font}>
          {text === t("Да") ? (
            <CheckCircleOutlined className={s.green} />
          ) : (
            <CloseCircleOutlined className={s.red} />
          )}
        </div>
      ),
    },
    {
      title: t("Информация"),
      dataIndex: `details`,
      align: "center",
      width: 20,
    },
  ];

  console.log("users", users);

  useEffect(() => {
    if (usersList) {
      setUsers(usersList);
    }
  }, [dispatch, usersList]);

  const currentPageRef = useRef(currentPage);

  useEffect(() => {
    currentPageRef.current = currentPage;
    dispatch(setUsersCurrentPage(currentPage));
  }, [currentPage, dispatch]);

  const getNextPage = async (page: number) => {
    setCurrentPage(page);
    dispatch(setUsersCurrentPage(page));

    currentPageRef.current = page;

    if (page === undefined || page === null) return;

    try {
      const res = await dispatch(getAdminUsersList(page));
      if (!res.payload || !("results" in res.payload)) {
        console.error("Unexpected API response:", res);
        return;
      }

      if (res.type === "users/getAdminUsersList/fulfilled") {
        if ("results" in res.payload) {
          // setData(res.payload.results);
          setPagination({
            current: res?.payload?.pagination?.current_page,
            pageSize: res?.payload?.pagination.page_size,
            total: res.payload.pagination.total_items,
          });
        } else {
          console.error("Unexpected API response:", res.payload);
        }
      }
    } catch (error) {
      console.error("Error in getNextPage:", error);
    }
  };

  return (
    <div>
      {width > 985 ? <Header /> : <MobileHeader />}
      <div className={s.content}>
        <h2 className={s.h2}>{t("Пользователи")}</h2>
        <div className={s.users}>
          {width > 750 ? (
            <Table
              columns={columns}
              pagination={{
                ...pagination,
                size: width > 900 ? "default" : "small",
              }}
              dataSource={users?.results.map((it, index) => ({
                number: index + 1,
                name: it.full_name,
                email: it.email,
                phone: it.phone,
                role: it.role,
                is_active: it.is_active ? "Да" : "Нет",
                email_verified: it.email_verified ? "Да" : "Нет",
                details: (
                  <Link
                    to={`/user/${it.id}`}
                    className={s.edit}
                    onClick={() => dispatch(getUserDetails(it.id))}
                  >
                    <Tooltip title={t("Просмотр/Редактирование")} key={1}>
                      <EditOutlined />
                    </Tooltip>
                  </Link>
                ),
              }))}
              onChange={(pagination) => {
                if (pagination?.current) {
                  getNextPage(pagination.current);
                }
              }}
            />
          ) : (
            <MobileUsersListTable />
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Users;
